/// <amd-module name="Repos/Tfvc/Views/ChangeDetails/Components/ChangeDetails" />
import * as React from "react";
import { IChange } from "Repos/ChangesCommon/Contracts";
import * as Resources from "Repos/Tfvc/Views/ChangeDetails/Resources";
import { ObservableCollection } from "VSS/Core/Observable";
import { ScreenSize } from "VSS/Core/Util/Screen";
import { PerformanceScenario, PerformanceScenarioContext } from "VSS/Platform/Components/Performance";
import { Observer } from "VSSUI/Observer";
import { Page } from "VSSUI/Page";
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { IVssContributedTab, TabBar } from "VSSUI/Tabs";
import { css } from "VSSUI/Util";
import { ScreenSizeObserver } from "VSSUI/Utilities/ScreenSize";
import { useChangeDetailsContext } from "../ChangeDetailsContext";
import { ChangeDetailsTab } from "./ChangeDetailsTab";
import { ChangeDetailsFilesTab } from "./ChangeFilesTab";
import { ChangeDetailsHeader } from "./ChangeHeader";
import { ChangeDetailsTabContent } from "./ChangeTabContent";

function getBuiltInChangeDetailsTabs(): IVssContributedTab[] {
    return [
        {
            id: "files",
            name: Resources.FilesTabName,
            render: () => <ChangeDetailsFilesTab />
        },
        {
            id: "details",
            name: Resources.DetailsTabName,
            render: () => <ChangeDetailsTab />
        }
    ];
}

export const ChangeDetails = (): JSX.Element => {
    const { perfContext, navigationService, viewService } = useChangeDetailsContext();
    const { scenarioName } = perfContext;

    const tabs = new ObservableCollection<IVssContributedTab>();
    tabs.push(getBuiltInChangeDetailsTabs());

    let currentTabId = viewService.getSelectedTabId().value;
    let currentItemPath = navigationService.getSelectedItem().value.path;

    return (
        <PerformanceScenario area="Tfvc" scenarioName={scenarioName} tti={true}>
            <Surface background={SurfaceBackground.neutral}>
                <Page className="custom-scrollbar scroll-auto-hide flex-grow" selectedTabId={viewService.getSelectedTabId()} tabProviders={tabs}>
                    <ScreenSizeObserver>
                        {(screenProps: { screenSize: ScreenSize }) => {
                            return <ChangeDetailsHeader screenSize={screenProps.screenSize} />;
                        }}
                    </ScreenSizeObserver>
                    <Observer selectedTabId={viewService.getSelectedTabId()}>
                        {({ selectedTabId }: { selectedTabId: string }) => {
                            return (
                                <>
                                    <TabBar onSelectedTabChanged={tabId => viewService.setSelectedTabId(tabId)} />
                                    <div
                                        className={css(
                                            "page-content flex-column flex-noshrink flex-grow",
                                            selectedTabId === "files" && "padding-horizontal-0 padding-bottom-0",
                                            selectedTabId !== "files" && "page-content-top"
                                        )}
                                    >
                                        <ChangeDetailsTabContent />
                                    </div>
                                    <PerformanceScenarioContext.Consumer>
                                        {scenarioProps => {
                                            return (
                                                <Observer selectedItem={navigationService.getSelectedItem()}>
                                                    {(selectionProps: { selectedItem: IChange }) => {
                                                        const newPath = selectionProps.selectedItem.path !== currentItemPath;
                                                        const newTab = selectedTabId !== currentTabId;

                                                        if (newPath || newTab) {
                                                            const newScenario = scenarioProps.resetScenario()!;
                                                            newScenario.addProperties({ inPageNavigate: true });
                                                            newScenario.addProperties({ switchFiles: newPath });
                                                            newScenario.addProperties({ switchTabs: newTab });

                                                            currentItemPath = selectionProps.selectedItem.path;
                                                            currentTabId = selectedTabId;

                                                            scenarioProps.getScenario()!.addProperties({
                                                                isFolder: selectionProps.selectedItem.isFolder,
                                                                tab: selectedTabId
                                                            });
                                                        }

                                                        return null;
                                                    }}
                                                </Observer>
                                            );
                                        }}
                                    </PerformanceScenarioContext.Consumer>
                                </>
                            );
                        }}
                    </Observer>
                </Page>
            </Surface>
        </PerformanceScenario>
    );
};
